// extracted by mini-css-extract-plugin
module.exports = {"pintxo-expander-header":"ExpanderHeader_pintxo-expander-header__WpyVf"};